export default "__VITE_ASSET__622f4c5c__"